import { DevGuidedTour } from "../../dev-guided-tour";
import loginGuide from "./auth/login.guide";

export default [
    ...loginGuide
] as DevGuidedTour[];